import Vue from 'vue/dist/vue.esm'
import esMX from '../../../config/locales/es-MX.yml'
import en from '../../../config/locales/en.yml'
import fr from '../../../config/locales/fr.yml'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es-MX',
  fallbackLocale: 'en',
  messages: {
    'es-MX': esMX['es-MX'],
    en: en.en,
    fr: fr.fr,
  },
})

export default i18n
